import { createPageSlice } from "./createPageSlice";

// Server-paginated slice for the "InOpTra's Team Member - Manager Mapping" (reporting) Master Data grid.
// Sorted by id since member/manager/client columns are enriched remotely and not sortable server-side.
const memberReportingPageSlice = createPageSlice("memberReportingPage", {
    defaultSortBy: "id",
    defaultSortDirection: "ASC",
});

export const memberReportingPageActions = memberReportingPageSlice.actions;
export default memberReportingPageSlice;
